// extracted by mini-css-extract-plugin
export var borderRadius = "_ba-4";
export var large = "_ba-3";
export var logoContainer = "_ba-0";
export var nameLogo = "_ba-2";
export var small = "_ba-1";